export default "__VITE_ASSET__BBk$r6Y1__"